import {
  FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_FAILURE,
  FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_REQUEST,
  FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_SUCCESS,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
  siteId: null,
  dateRange: null,
  receivedAt: null,
};

const generalEquipmentEnergyTotalTrendReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        siteId: action.meta?.siteId,
        dateRange: action.meta?.dateRange,
      };
    case FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
        siteId: action.meta?.siteId,
        dateRange: action.meta?.dateRange,
        receivedAt: action.meta?.receivedAt || Date.now(),
      };
    case FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        siteId: action.meta?.siteId,
        dateRange: action.meta?.dateRange,
      };
    default:
      return state;
  }
};

export default generalEquipmentEnergyTotalTrendReducer;
